import { render, staticRenderFns } from "./TabHeightChart.vue?vue&type=template&id=9db1ce1e&scoped=true&"
import script from "./TabHeightChart.vue?vue&type=script&lang=js&"
export * from "./TabHeightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db1ce1e",
  null
  
)

export default component.exports